/**
 * Global content protection — disables right-click and drag on any <img>
 * or element marked with data-protected="true".
 *
 * Import once from App.js. Runs on window (not React) so the interception is
 * active immediately and covers dynamically-rendered images.
 *
 * NOTE: A determined attacker can always screenshot. This is intentional
 * casual-copy protection paired with server-side watermarking.
 */
export function installContentProtection() {
  if (typeof window === "undefined") return;
  if (window.__dhe_protection_installed) return;
  window.__dhe_protection_installed = true;

  const isProtected = (el) => {
    if (!el) return false;
    if (el.dataset && el.dataset.protected === "true") return true;
    // Also protect anything inside .protected-region
    let cur = el;
    while (cur && cur !== document.body) {
      if (cur.dataset && cur.dataset.protected === "true") return true;
      if (cur.classList && cur.classList.contains("protected-region")) return true;
      cur = cur.parentElement;
    }
    return false;
  };

  window.addEventListener(
    "contextmenu",
    (e) => {
      const t = e.target;
      // Always block right-click on images inside the marketplace
      if (t && (t.tagName === "IMG" || isProtected(t))) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      return true;
    },
    { capture: true }
  );

  window.addEventListener(
    "dragstart",
    (e) => {
      const t = e.target;
      if (t && (t.tagName === "IMG" || isProtected(t))) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      return true;
    },
    { capture: true }
  );
}

export default installContentProtection;
